module.exports = __webpack_public_path__ + "img/otoride-logo-v2-1x.21e6c6ec.png";